import React from "react";
import PlusSVG from "../../../assets/icons/increase-serving.svg";
import { combineClasses } from "../../../utils/combineClasses";

// Light Gray Plus Icon
export const PlusIcon: React.FC<{ className?: string }> = ({ className = "w-[17.8px] h-[17.8px]" }) => {
  return <img src={PlusSVG} alt="" className={combineClasses("cursor-pointer", className)} />;
};
